import { render, staticRenderFns } from "./MapHighlightDeptos.vue?vue&type=template&id=83333056"
import script from "./MapHighlightDeptos.vue?vue&type=script&lang=js"
export * from "./MapHighlightDeptos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports